(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/free-reduction/data.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/free-reduction/data.js'); "use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (svs) {
  var ReduceData = function () {
    function ReduceData(rows, outcome, weight) {
      _classCallCheck(this, ReduceData);

      this.rows = rows; 

      this.outcome = outcome; 

      this.weight = weight; 

      this.actual = 0; 

      this.picks = 0; 
    }

    _createClass(ReduceData, [{
      key: "getDistanceFromTargetWeight",
      value: function getDistanceFromTargetWeight() {
        var targetWeight = this.weight,
            currentWeight = this.actual;
        return Math.abs(targetWeight - currentWeight);
      }
    }, {
      key: "updateActual",
      value: function updateActual(totalPicks) {
        var newActualWeight;

        if (this.picks === 0) {
          newActualWeight = 0;
        } else {
          newActualWeight = this.picks / totalPicks * 100;
        }

        this.actual = newActualWeight;
      }
    }]);

    return ReduceData;
  }();

  svs.tipset.freeReduction.ReduceData = ReduceData;
})(svs);
 })(window);